module.exports = __webpack_public_path__ + "img/free.dd5cd09d.jpg";